import { Checkbox as ChakraCheckbox } from '@chakra-ui/react';
import * as React from 'react';

import { Show } from 'shared/components/Show';

export interface CheckboxProps extends ChakraCheckbox.RootProps {
  icon?: React.ReactNode;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  rootRef?: React.RefObject<HTMLLabelElement | null>;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  function Checkbox(props, ref) {
    const { icon, children, inputProps, rootRef, ...rest } = props;
    return (
      <ChakraCheckbox.Root ref={rootRef} {...rest}>
        <ChakraCheckbox.HiddenInput ref={ref} {...inputProps} />
        <Show when={icon}>{icon}</Show>
        <Show when={!icon}>
          <ChakraCheckbox.Control>
            <ChakraCheckbox.Indicator />
          </ChakraCheckbox.Control>
        </Show>
        {children != null && (
          <ChakraCheckbox.Label>{children}</ChakraCheckbox.Label>
        )}
      </ChakraCheckbox.Root>
    );
  }
);
